<div class="pos-panel">
    <div class="pos-new-entity-header">
        <div class="w-50">
            <span class="material-icons cyan float-start">restaurant</span>
            <span class="soc-panel-h float-start ms-3">{{'MENU_ITEM.MENU_ITEM_DETAILS' | translate }}</span>
        </div>
        <div class="w-50">
            <span (click)="$event.stopPropagation(); actionMenuItem.toggle($event)"
                class="material-icons neutral-90 float-end"
                style="font-size: 25px; border-radius: 5px; background-color: var(--soc-neutral-50);">more_vert</span>
            <p-overlayPanel #actionMenuItem [dismissable]="true" class="d-none">
                <div class="soc-action-menu-content">
                    <div class="soc-action-item" (click)="editMenuItem(menuItem)">
                        {{'MENU.EDIT_MENU_ITEM' | translate}}</div>
                    <div class="soc-action-item" (click)="deleteMenuItem(menuItem)">
                        {{'MENU.DELETE_MENU_ITEM' | translate}}</div>
                </div>
            </p-overlayPanel>
        </div>
    </div>
    <hr class="soc-panel-line" />
    <div class="soc-wrapper-gap-24" style="height: calc(100vh - 363px);">
        <div class="w-50 h-100 soc-wrapper-gap-24-column" >
            <div>
                <div class="mb-4 d-flex" style="gap: 20px;">
                    <img class="" style="border-radius: 8px; width: 96px; height: 96px;"
                        [src]="!menuItem.imageUrl? imagePath : menuItem.imageUrl ">
                    <div class="w-100 d-grid">
                        <div class="pos-site-desc">
                            <h3>{{menuItem.name }} </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pos-site-desc">
                <span>{{'MENU.CATEGORIZATION' | translate }} </span>
                <div pTooltip="CATEGORIZATION" class="material-icons soc-info">info</div>
            </div>
            <div class="d-flex" style="gap:20px">
                <div class="w-50 d-grid">
                    <label class="soc-input-lbl" style="height: 24px;">{{'MENU.CATEGORY'| translate}}</label>
                    <hr class="soc-panel-line mb-3" />
                    <label class="soc-lbl-text" style="height: 24px;">{{menuItem.menuCategory?.name}}</label>
                    <hr class="soc-panel-line" />
                </div>
                <div class="w-50 d-grid">
                    <label class="soc-input-lbl soc-neutral-50-text-color" style="height: 24px;">{{'MENU.SUBCATEGORY'|
                        translate}}</label>
                    <hr class="soc-panel-line mb-3" />
                    <label class="soc-lbl-text" style="height: 24px;">{{menuItem.menuSubcategory?.name}}</label>
                    <hr class="soc-panel-line" />
                </div>
            </div>
            <div class="pos-site-desc">
                <span>{{'MENU.PRICING' | translate }} </span>
                <div pTooltip="PRICING" class="material-icons soc-info">info</div>
            </div>
            <div class="d-flex" style="gap:20px">
                <div class="w-50 d-grid">
                    <label class="soc-input-lbl" style="height: 24px;">{{'MENU.PRICE'|translate}}
                        <span class="soc-neutral-50-text-color">({{'MENU.NET_AMOUNT'|translate}}) </span>
                    </label>
                    <hr class="soc-panel-line mb-3" />
                    <label class="soc-lbl-text" style="height: 24px;">{{currency && currency.shortName ? (menuItem.price | currency: currency.shortName) : menuItem.price}}</label>
                    <hr class="soc-panel-line" />
                </div>
                <div class="w-50 d-grid">
                    <label class="soc-input-lbl" style="height: 24px;">{{'MENU.TAX_RATE'| translate}}</label>
                    <hr class="soc-panel-line mb-3" />
                    <label class="soc-lbl-text" style="height: 24px;">{{menuItem.taxRate?.rate}}%</label>
                    <hr class="soc-panel-line" />
                </div>
            </div>
        </div>
        <div class="w-50 h-100 soc-wrapper-gap-24-column">
            <div class="pos-site-desc">
                <span>{{'MENU.INGREDIENTS' | translate }} </span>
                <div pTooltip="ALL INGREDIENTS" class="material-icons soc-info">info</div>

            </div>
            <p-table class="soc-borderless-cyan-table soc-editable-table h-100" [responsive]="true"
                [value]="menuItem.menuItemIngredients! " [scrollable]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 50%;">{{'MENU.INVENORY_ITEM' | translate }}</th>
                        <th style="width: 50%;">{{'MENU.QUANTITY' | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <ng-container>
                        <tr>
                            <td style="padding: 20px 0px !important;">
                                <label class="soc-lbl-text" style="height: 24px;">{{item.stockItem.name}}</label>
                            </td>
                            <td style="padding: 20px 0px !important;">
                                <label class="soc-lbl-text" style="height: 24px;">{{item.quantity}}
                                    <span> {{item.stockItem.unitType | unitShortener | lowercase}}</span>
                                </label>
                            </td>
                        </tr>
                    </ng-container>
                </ng-template>
            </p-table>
            <hr class="soc-panel-line-cyan" />
        </div>
    </div>
    <hr class="soc-panel-line" />
    <div class="soc-wrapper-gap-12 justify-content-start">
        <button class="soc-secondary-grey-btn" (click)="back()"><i class="material-icons me-1">arrow_back</i> {{'BACK' |
            translate }}</button>
    </div>
</div>

<p-confirmDialog class="soc-confirmation-dialog">   
</p-confirmDialog>